import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import LoadingScreen from "@/components/LoadingScreen";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsappButton from "@/components/WhatsappButton";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import ServiceDetail from "@/pages/ServiceDetail";
import UeberUns from "@/pages/UeberUns";
import FAQ from "@/pages/FAQ";
import Kontakt from "@/pages/Kontakt";
import LegalStub from "@/pages/LegalStub";

function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="App font-sans bg-messinger-bg text-messinger-dark">
      {!loaded && <LoadingScreen onDone={() => setLoaded(true)} />}
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main data-testid="site-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/leistungen/:slug" element={<ServiceDetail />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<LegalStub title="Impressum" />} />
            <Route path="/datenschutz" element={<LegalStub title="Datenschutz" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <WhatsappButton />
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
